import { combineReducers } from 'redux';

import { ADD } from './constants';

const adding = (state = false, action) => {
    const { type } = action;

    switch (type) {
        case ADD.REQUEST: {
            return true;
        }
        case ADD.SUCCESS:
        case ADD.FAILED: {
            return false;
        }
        default: {
            return state;
        }
    }
};

export default combineReducers({
    adding
});
